<template>
  <div class="account-view">
    <!-- 代理信息部分 -->
    <div class="section">
      <div class="section-title">{{$t('proxy.text25')}} </div>
      <div class="section-content mt-20">
        <div class="info-item">
          <div class="info-label">{{$t('proxy.text26') + '：'}}</div>
          <div class="info-value">{{ proxyData.name || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{$t('proxy.text27') + '：'}}</div>
          <div class="info-value">{{ proxyData.contracter || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{$t('proxy.text28') + '：'}}</div>
          <div class="info-value">{{ proxyData.contacterphone || '--' }}</div>
        </div>
      </div>
    </div>

    <!-- 个人信息部分 -->
    <div class="section">
      <div class="section-title">{{ $t('followOrder.text120') }}</div>
      <div class="section-content mt-20">
        <div class="info-item">
          <div class="info-label">{{$t('proxy.text33') + '：'}}</div>
          <div class="info-value">{{ userData.fundAccountName || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{$t('proxy.text34') + '：'}}</div>
          <div class="info-value">{{ userData.email || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{$t('proxy.text39') + '：'}}</div>
          <div class="info-value">{{ webAccounts.join('、') || '--' }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">{{$t('proxy.text216') + '：'}}</div>
          <div class="info-value">{{ mt4Accounts.join('、') || '--' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import apiService from '@/api/request' // 假设你的 API 请求文件在这个路径

// 代理信息和用户信息
const proxyData = ref({
  name: '',
  contracter: '',
  contacterphone: '',
})
const userData = ref({
  fundAccountName: '',
  email: '',
})

// Web账号和MT4账号
const webAccounts = ref([])
const mt4Accounts = ref([])

// 获取个人信息的API请求
const fetchUserInfo = () => {
  apiService.proxyPersonInfo().then((response) => {
    const data = response.data;
    if (data) {
      proxyData.value = data.proxy || {};
      userData.value = data.user || {};
      webAccounts.value = data.user.web || [];
      mt4Accounts.value = data.user.mt4 || [];
    }
  }).catch((error) => {
    console.error('获取用户信息失败', error);
  })
}

// 页面加载时调用API获取信息
onMounted(() => {
  fetchUserInfo()
})

</script>

<style scoped>
.info-item {
  font-family: PingFangSC, PingFang SC;
  display: flex;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 20px;
}
.info-label {
  flex: 0 0 148px;
  width: 148px;
}
.info-value {
  flex: 1 1 auto;
}
</style>
